import * as Sentry from '@sentry/browser';
import { auth } from '../../constants/firebaseModular';

export const requestDomainDiscount = async (domain: string, uid: string, product: string) => {
  try {
    const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/api/discountCodes?domain=${domain}&uid=${uid}&product=${product}`;
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      throw new Error('No token found');
    }

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const res = await fetch(url, {
      method: 'POST',
      headers: myHeaders,
    });

    if (res.status !== 200) {
      alert(`ERROR: ${res.status}: ${res.statusText}`);
      throw new Error(`ERROR: ${res.status}: ${res.statusText}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error requesting domain discount', error);
    Sentry.captureException(error);
  }
};
